import React, { useState, useRef, useEffect, useContext } from 'react';
import { context } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { getSubtitle } from '@catalogo/ui-americanas-desktop-product-review/src/helpers';
import { useFilterBook } from '@catalogo/ui-americanas-desktop-product-review/src/hooks';
import { withFilters } from '@catalogo/ui-americanas-desktop-product-review/src/hocs';
import DropDown from '../../atoms/DropDown';
import { Select, Option, Checkmark } from './Styled';

export interface TypeOfReviewProps {
  filters?: number[];
  allNotes?: string;
  dispatchMetrics: (metricName: string, data: any) => void;
  filterVerified: () => void;
  filterSkoob: () => void;
}
// eslint-disable-next-line max-lines-per-function
const FilterType = (props: TypeOfReviewProps) => {
  const { dispatchMetrics, filterSkoob, filterVerified } = props;
  const { config, queryParam } = useContext<any>(context);
  const { breadcrumb } = config;
  const { isBook } = useFilterBook({ breadcrumb });
  const ref = useRef(null);
  const [verified, setVerified] = useState<boolean>(false);
  const [skoob, setSkoob] = useState<boolean>(false);
  const [subtitle, setSubtitle] = useState('');

  const onChangeVeriPurchaser = () => {
    filterVerified();
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'comprou-e-avaliou',
      label: `filtro ${!verified ? 'aplicado' : 'retirado'}`,
    });
  };

  const onChangeSkoob = () => {
    filterSkoob();
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'resenha-skoob',
      label: `filtro ${!skoob ? 'aplicado' : 'retirado'}`,
    });
  };
  useEffect(() => {
    if (queryParam?.badges == 'verified_purchaser') {
      setVerified(true);
    } else {
      setVerified(false);
    }
    if (queryParam?.badges == 'skoob') {
      setSkoob(true);
    } else {
      setSkoob(false);
    }
    setSubtitle(getSubtitle(queryParam));
  }, [queryParam]);

  useEffect(() => {
    if (queryParam.badges == null) {
      setSkoob(false);
      setVerified(false);
    }
  }, [queryParam]);

  const skoobFilter = isBook && (
    <Option key="skoob" className="product-review-type-of-review-option">
      <label htmlFor="skoob"> resenha skoob</label>
      <Checkmark
        onClick={onChangeSkoob}
        onChange={onChangeSkoob}
        checked={skoob}
        className="product-review-type-of-review-option-checkmark"
      />
    </Option>
  );
  return (
    <>
      <DropDown
        subTitle={subtitle}
        ref={ref}
        title="tipo de avaliação"
        id="filter-rating"
        shouldGetElementHeightOnRender={false}
        visibilityOnInit={false}
        metricId="review"
        anchorRef="#card-reviews-title"
      >
        <Select className="product-review-type-of-review">
          <Option key="verified_purchaser" className="product-review-type-of-review-option">
            <label htmlFor="verified_purchaser">comprou e avaliou</label>
            <Checkmark
              onClick={onChangeVeriPurchaser}
              onChange={onChangeVeriPurchaser}
              checked={verified}
              className="product-review-type-of-review-option-checkmark"
            />
          </Option>
          {skoobFilter}
        </Select>
      </DropDown>
    </>
  );
};

FilterType.defaultProps = {
  filters: [5, 4, 3, 2, 1],
  allNotes: 'todas as notas',
};
const TypeOfReview = withFilters(FilterType);
export default TypeOfReview;
export { TypeOfReview };
